import { FC } from "react";

export const IconFileCSV: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 11.5L12 14.5L13.25 11.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 14.1562C4.76078 14.3749 4.44911 14.4974 4.125 14.5C3.3625 14.5 2.75 13.8313 2.75 13C2.75 12.1687 3.3625 11.5 4.125 11.5C4.44911 11.5026 4.76078 11.6251 5 11.8438"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 14.25C7.27088 14.452 7.59957 14.5616 7.9375 14.5625C8.5 14.5625 9 14.375 9 13.75C9 12.75 7 13.1875 7 12.25C7 11.75 7.375 11.4375 7.9375 11.4375C8.27543 11.4384 8.60412 11.548 8.875 11.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9V1.5C3 1.36739 3.05268 1.24021 3.14645 1.14645C3.24021 1.05268 3.36739 1 3.5 1H9.5L13 4.5V9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 1V4.5H13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
